import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import Store from 'store/store';
import { findInVNode } from 'utils/vnode';

import s from 'base/bolt/boltApp.sss';

const mgmSwitch = typeof window !== 'undefined' && Date.now() >= 1672587000000;

export default class BoltApp extends BaseComp.default {
	constructor(props) {
		super(props);
		let appData = this.state.appState.appData;
		if (mgmSwitch && appData?.options?.mgmSwitch) {
			if (location.host === 'www.unitedartistsreleasing.com') {
				location.host = 'www.mgmstudios.com';
			}
			const uarHeader = appData.header?.uarHeader;
			if (uarHeader?.logo) {
				uarHeader.logo.src = uarHeader.logo.src?.replace('uar-logo.png', 'mgm-logo.png');
			}
			Object.values(uarHeader?.nav || {}).forEach((navItem) => {
				if (navItem?.path) {
					navItem.path = navItem.path.replace('www.unitedartistsreleasing.com', 'www.mgmstudios.com');
				}
			});
			const uarFooter = appData.footer?.uarFooter;
			if (uarFooter?.logo) {
				uarFooter.logo.src = uarFooter.logo.src?.replace('uar-logo.png', 'mgm-logo.png');
			}
			if (uarFooter?.copyright?.studio?.$copy?.includes('2022')) {
				uarFooter.copyright.studio.$copy = '© 2024 Metro-Goldwyn-Mayer Pictures Inc. All Rights Reserved.';
			}
			Store.get().set({ appData }).now();
		}
	}

	render(props, state) {
		const base = super.render(props, state);
		const hasUarHeader = state?.appState?.appData?.header?.uarHeader;
		// const hasVideoBackground = state?.appState?.appData?.urls.roots.video;
		const isDesktopSize = state?.appState?.client?.isDesktopSize;
		const background = findInVNode(base, `.${s.background}`);
		const bgVideo = findInVNode(base, `.${s.bgVideo}`);
		if (hasUarHeader && !isDesktopSize && background) {
			let newBackgroundPosition = background.attributes.style.backgroundPosition;

			switch (newBackgroundPosition) {
				case 'center center':
					newBackgroundPosition = 'center 64px';
					break;
				case 'center top':
					newBackgroundPosition = 'center 64px';
					break;
				case 'left center':
					newBackgroundPosition = 'left 64px';
					break;
				case 'left top':
					newBackgroundPosition = 'left 64px';
					break;
				case 'right center':
					newBackgroundPosition = 'right 64px';
					break;
				case 'right top':
					newBackgroundPosition = 'right 64px';
					break;
			}

			background.attributes.style = {
				...background.attributes.style,
				backgroundPosition: newBackgroundPosition,
			};
		}
		if (hasUarHeader && !isDesktopSize && bgVideo) {
			bgVideo.attributes.style = {
				...bgVideo.attributes.style,
				height: 'calc(100% - 64px)',
				marginTop: '64px'
			};
		}
		return base;
	}
}
